import { ACTION_TYPES } from './actionTypes'

export const creditAction = (payload) => ({
	type: ACTION_TYPES.CREDIT,
	payload,
})
